import { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import Api from "../../components/api/Api";
import Notification, { showToast } from "../../../components/common/notification/Notification";

const LocationServiceSelector = ({ userId }) => {
  const [profile, setProfile] = useState({
    id: userId,
    state_id: "",
    city_id: "",
    service_id: "",
  });

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [services, setServices] = useState([]);
  const [isCityDisabled, setIsCityDisabled] = useState(true);

  const getUserApi = Api({ url: `admin/user/id/${userId}` });
  const editUserApi = Api({ url: `admin/editUser` });
  const statesApi = Api({ url: `admin/states/1` });
  const servicesApi = Api({ url: `admin/services` });
  const cityApi = Api({ url: `admin/cities/${profile.state_id}` });

  useEffect(() => {
    if (userId) {
      fetchUserData();
      fetchStates(); 
      fetchServices();
    }
  }, [userId]);

  const fetchUserData = async () => {
    try {
      const res = await getUserApi.fetchData();
      const user = res.data.user;
      // console.log(user)

      setProfile({
        id: userId,
        state_id: user.states[0]?.id || "",
        city_id: user.cities[0]?.id || "",
        service_id: user.service_id || "",
      });

      if (user.states?.[0]?.id) fetchCities(user.states[0].id);
    } catch (err) {
      console.error("Error fetching user:", err);
    }
  };

  const fetchStates = async () => {
    try {
      const res = await statesApi.fetchData();
      if (res.data.statusType === "SUCCESS") setStates(res.data.states);
    } catch {
      setStates([]);
    }
  };

  const fetchCities = async () => {
    try {
      const res = await cityApi.fetchData();
      console.log(res) 
      if (res.data.statusType === "SUCCESS") {
        setCities(res.data.cities);
        setIsCityDisabled(false);
      }
    } catch {
      setCities([]);
      setIsCityDisabled(true);
    }
  };

  const fetchServices = async () => {
    try {
      const res = await servicesApi.fetchData();
      setServices(res.data.services || []);
    } catch {
      setServices([]);
    }
  };

  // Auto-save on change
  const handleChange = async (field, value) => {
    let updatedProfile = { ...profile, [field]: value };

    // If state changes, reset city and fetch new cities
    if (field === "state_id") {
      updatedProfile.city_id = "";
      setProfile(updatedProfile);
      fetchCities(value);
    } else {
      setProfile(updatedProfile);
    }

    try {
      console.log(updatedProfile) 
      const res = await editUserApi.editData(updatedProfile);
      console.log(res)
      // if (res.data.statusType === "SUCCESS") {
      //   showToast("Updated successfully", { type: "success" });
      // } else {
      //   showToast("Update failed", { type: "error" });
      // }
    } catch (err) {
      console.error("Error updating profile:", err);
      showToast("Error updating profile", { type: "error" });
    }
  };

  return (
    <>
      <Notification />
      <Row className="mb-3">
        {/* State */}
        <Col md={4}>
          <Form.Group>
            <Form.Label>State</Form.Label>
            <Form.Select
              value={profile.state_id}
              onChange={(e) => handleChange("state_id", e.target.value)}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* City */}
        <Col md={4}>
          <Form.Group>
            <Form.Label>City</Form.Label>
            <Form.Select
              value={profile.city_id}
              onChange={(e) => handleChange("city_id", e.target.value)}
              disabled={isCityDisabled}
            >
              <option value="">Select City</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Service */}
        <Col md={4}>
          <Form.Group>
            <Form.Label>Service</Form.Label>
            <Form.Select
              value={profile.service_id}
              onChange={(e) => handleChange("service_id", e.target.value)}
            >
              <option value="">Select Service</option>
              {services.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default LocationServiceSelector;
